import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface UsePageViewOptions {
  disabled?: boolean;
}

const usePageView = ({ disabled }: UsePageViewOptions): void => {
  const router = useRouter();

  useEffect(() => {
    if (disabled) return;

    const handleRouteChange = (): void => {
      window.dataLayer = window.dataLayer || [];

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'page_view',
        });
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    // handle initial pageview
    handleRouteChange();

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, disabled]);
};

export default usePageView;
